import React from "react";
import styled, { css } from "styled-components";
import { v4 as uuid } from "uuid";
import { useMappedState } from "redux-react-hook";
import ReactTooltip from "react-tooltip";

import { Text } from "src/library/components/Text";
import { Tooltip } from "src/library/components/Tooltip";
import { IStore } from "src/core/shared/store";

import { IOrderVariant } from "../api/orders.api";

export interface OrderVariantLabelProps {
  orderVariant: IOrderVariant;
  place?: ReactTooltip.Place
}

const OrderVariantLabel: React.ReactFCWithChildren<OrderVariantLabelProps> = (({ orderVariant, place }) => {
  const tippyKey = `${uuid()}`;

  const { orderVariants } = useMappedState(({ global }: IStore) => ({
    role: global.role,
    orderVariants: global.settings ? global.settings.orderVariants || [] : []
  }));

  if (orderVariants.length > 1) {
    return (
      <OrderVariantLabelWrapper variantColor={orderVariant.color}>
        {orderVariant.description && (
          <Tooltip
            disable={false}
            id={`${tippyKey}-order-variant-tool-tip`}
            type="dark"
            place={place ? place : "top"}
            getContent={() => {
              return (
                <Text
                  color="white"
                >
                  {orderVariant.description}
                </Text>
              );
            }}
          />
        )}

        <div
          className={`${orderVariant.description ? "has-description" : ""} order-variant-tag`}
          data-tip
          data-for={`${tippyKey}-order-variant-tool-tip`}
        >
          <Text
            color="white"
            weight="bold"
          >
            {orderVariant.name}
          </Text>
        </div>

      </OrderVariantLabelWrapper>
    );
  } else {
    return <></>;
  }
});

const OrderVariantLabelWrapper = styled.div<{variantColor: string}>`
  ${({ theme, variantColor }) => css`
      background: ${variantColor};
      color: white;
      padding: ${theme.spacing.padding.xs};
      height: 25px;
      min-width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: ${theme.borderRadius};
      width: fit-content;

      &.has-description:hover {
        cursor: help;
        }

      .order-variant-tag span {
        display: inline-block;
        text-align: center;
      }
    `}
  `;

export default OrderVariantLabel;
